import { render, staticRenderFns } from "./MunicipiosComp.vue?vue&type=template&id=5891f6f6&scoped=true&"
import script from "./MunicipiosComp.vue?vue&type=script&lang=js&"
export * from "./MunicipiosComp.vue?vue&type=script&lang=js&"
import style0 from "./MunicipiosComp.vue?vue&type=style&index=0&id=5891f6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891f6f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VIcon,VRow})
